export default __webpack_public_path__ + "img/accha/accha1_700.jpg";